<template>
  <div id="product">
    <!-- Loader -->
    <loader v-if="loaderActive"></loader>
    <section id="banner" v-if="bannerList.length > 0">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <carousel :id="'bannerCarousel'"
                      :index="bannerIndex"
                      :itemList="bannerList"
                      :interval="10000"
                      :showControl="showBannerControl"
                      :showIndicator="windowWidth > 767"
                      >
            </carousel>
            <!-- Page -->
            <div class="hz-carousel-page visible-xs">{{ pageText }}</div>
          </div>
        </div>
      </div>
    </section>
    <section id="benefit">
      <div class="container">
        <p class="orange-tag">제품구매</p>
        <h2>회원사 혜택</h2>
        <p class="description">비즈해줌에서만 가능한 특별한 서비스를 제공합니다.</p>
        <div class="row">
          <div class="col-sm-4 col-xs-12 ">
            <div class="box">
              <div class="icon">
                <img src="~@/assets/svg/ic-shop-money.svg">
              </div>
              <div class="desc">
                <p>100만원 상당 비즈해줌 이용권 증정</p>
                <span>제품구매 확정 시</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4 col-xs-12">
            <div class="box">
              <div class="icon">
                <img src="~@/assets/svg/ic-shop-panel.svg">
              </div>
              <div class="desc">
                <p>예비용 패널 추가 증정</p>
                <span>라이젠 패널 200kW 이상 구매 시</span>
              </div>
            </div>
          </div>
          <div class="col-sm-4 col-xs-12 ">
            <div class="box">
              <div class="icon">
                <img src="~@/assets/svg/ic-shop-panel.svg">
              </div>
              <div class="desc">
                <p>제품 여신 제공</p>
                <span>회원사의 신용도, 제품 등에 따라 제한될 수 있음</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="recommend" v-if="recommendList.length">>
      <div class="container">
        <h2>추천 제품</h2>
        <p class="description">비즈해줌이 엄선한 제품들을 회원사 특가로 제공합니다.</p>
        <carousel :id="'recommendCarousel'" :options="{interval: 30000}" :showControl="windowWidth > 767">
          <div class="carousel-inner">
            <div class="row item" v-for="(item, index) in recommendList" :data-product-type="item.product_type" :data-manufacturer-name="item.name">
              <div class="col-md-offset-1 col-md-5 hidden-sm hidden-xs" :class="{'col-md-push-6': index % 2 == 1}">
                <img :src="item.product_img" class="img-product" :alt="`비즈해줌 제품구매 프로모션 ${item.name} 제품 이미지`">
              </div>
              <div class="col-sm-12 col-md-offset-1 col-md-5" :class="{'col-md-pull-6': index % 2 == 1}">
                <div class="brand-logo">
                  <img :src="item.image" class="img-responsive" :alt="`비즈해줌 제품구매 ${item.name} 브랜드 로고`">
                </div>
                <ul>
                  <li v-for="desc in item.desc">{{ desc }}</li>
                </ul>
              </div>
            </div>
          </div>
        </carousel>
        <div class="text-center">
          <button type="button" class="hz-btn-default hz-btn-lg" @click="downloadRecommendBrochure">자료 다운로드</button>
          <button type="button" class="hz-btn-primary hz-btn-lg" @click="showInquiryModal">가격문의</button>
        </div>
      </div>
    </section>
    <section id="promotion" v-if="promotionPackageList.rps.length || promotionPackageList.solarhome.length">
      <div class="container">
        <h2>초특가 프로모션 패키지</h2>
        <p class="description">고품질의 추천 제품을 특가로 제공합니다.</p>
        <div id="rpsPackage" class="row rps-package" v-if="promotionPackageList.rps.length > 0">
          <div class="col-md-3 col-xs-12">
            <h4 class="title">RPS 패키지 선택</h4>
            <ul class="nav nav-pills nav-stacked hidden-sm hidden-xs">
              <li :class="{'active': rps.id === pickedRpsPackageId }"
                  v-for="(rps, index) in promotionPackageList.rps"
                  :key="rps.id"
                  @click="pickedRpsPackageId = rps.id"
              >
                <a data-toggle="tab" :href="`#rpsPackage${rps.id}`" data-type="rps" :data-id="rps.id">{{ rps.name | nullCheck }}</a>
              </li>
            </ul>
            <div class="dropdown package-dropdown show hidden-lg hidden-md">
              <a class="dropdown-toggle" href="#" role="button" id="rpsDropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ selectedRpsPackageName }}
                <i class="glyphicon glyphicon-chevron-down"></i>
              </a>
              <div class="dropdown-menu padding-0" aria-labelledby="rpsDropdownMenu">
                <a data-toggle="tab"
                   :href="`#rpsPackage${rps.id}`"
                   :class="['dropdown-item', {'active': rps.id === pickedRpsPackageId }]"
                   v-for="(rps, index) in promotionPackageList.rps"
                   :key="rps.id"
                   @click="pickedRpsPackageId = rps.id"
                >
                  {{ rps.name | nullCheck }}
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-9 col-xs-12">
            <div class="tab-content">
              <div v-for="(rps, index) in promotionPackageList.rps"
                   :key="rps.id"
                   :id="`rpsPackage${rps.id}`"
                   :class="['tab-pane', 'fade', {'in': index === 0}, {'active': index === 0}]">
                <div class="tab-pane-header title">{{ rps.name | nullCheck }}</div>
                <div class="tab-pane-body">
                  <div class="row">
                    <div :class="[{'col-md-6': rps.emptyAdditionalFlag}, {'col-md-4': !rps.emptyAdditionalFlag}, 'col-xs-12']">
                      <div class="product">
                        <p class="product-type">패널</p>
                        <div class="product-img">
                          <img v-if="rps.module.product_img !== null" :src="rps.module.product_img" class="img-responsive" alt="비즈해줌 제품구매 프로모션 패키지 패널 이미지">
                          <img v-else src="~@/assets/img/product/biz-img-shop-module-default.png" class="img-responsive" alt="비즈해줌 제품구매 프로모션 패키지 패널 이미지">
                        </div>
                        <div class="product-logo">
                          <img v-if="rps.module.manufacturer.image !== null" :src="rps.module.manufacturer.image" class="img-responsive" alt="비즈해줌 제품구매 프로모션 패키지 패널 브랜드 로고">
                        </div>
                        <p class="product-name">{{ rps.module.name | nullCheck }} <span v-if="rps.module_more_name">{{ rps.module_more_name }}</span></p>
                      </div>
                      <div class="desc">
                        <p v-for="desc in rps.module.desc">{{ desc | nullCheck }}</p>
                      </div>
                    </div>
                    <div :class="[{'col-md-6': rps.emptyAdditionalFlag}, {'col-md-4': !rps.emptyAdditionalFlag}, 'col-xs-12']">
                      <div class="product">
                        <p class="product-type">인버터</p>
                        <div class="product-img">
                          <img v-if="rps.inverter.product_img !== null" :src="rps.inverter.product_img" class="img-responsive product-img" alt="비즈해줌 제품구매 프로모션 패키지 인버터 이미지">
                        </div>
                        <div class="product-logo">
                          <img v-if="rps.inverter.manufacturer.image !== null" :src="rps.inverter.manufacturer.image" class="img-responsive product-logo" alt="비즈해줌 제품구매 프로모션 패키지 인버터 브랜드 로고">
                        </div>
                        <p class="product-name">{{ rps.inverter.name | nullCheck }} <span v-if="rps.inverter_more_name">{{ rps.inverter_more_name }}</span></p>
                      </div>
                      <div class="desc">
                        <p v-for="desc in rps.inverter.desc">{{ desc | nullCheck }}</p>
                      </div>
                    </div>
                    <div v-if="!rps.emptyAdditionalFlag" class="col-md-4 col-xs-12 package-plus">
                      <div class="product">
                        <p class="product-type">추가구성</p>
                        <div class="product-img">
                          <img src="~@/assets/svg/ic-package-plus.svg" class="img-responsive">
                          <p>{{ rps.additional.category | nullCheck }}</p>
                        </div>
                        <div class="product-logo"></div>
                        <p class="product-name">{{ rps.additional.name | nullCheck }}</p>
                      </div>
                      <div class="desc">
                        <p v-for="desc in rps.additional.desc">{{ desc | nullCheck }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane-footer">
                  <button type="button"
                          class="hz-btn-primary hz-btn-lg"
                          @click="showInquiryModal({install_capacity: rps.capacity, module: rps.module.id, inverter: rps.inverter.id, is_promotion: true})"
                  >
                    가격문의
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="solarhomePackage" class="row solarhome-package" v-if="promotionPackageList.solarhome.length > 0">
          <div class="col-md-3 col-xs-12">
            <h4 class="title">주택용 패키지</h4>
            <ul class="nav nav-pills nav-stacked hidden-sm hidden-xs">
              <li :class="{'active': solarhome.id === pickedSolarhomePackageId}"
                  v-for="(solarhome, index) in promotionPackageList.solarhome"
                  :key="solarhome.id"
                  @click="pickedSolarhomePackageId = solarhome.id"
              >
                <a data-toggle="tab" :href="`#solarhomePackage${solarhome.id}`" data-type="solarhome" :data-id="solarhome.id">{{ solarhome.name | nullCheck }}</a>
              </li>
            </ul>
            <div class="dropdown package-dropdown show hidden-lg hidden-md">
              <a class="dropdown-toggle" href="#" role="button" id="solarhomeDropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ selectedSolarhomePackageName }}
                <i class="glyphicon glyphicon-chevron-down"></i>
              </a>
              <div class="dropdown-menu padding-0" aria-labelledby="solarhomeDropdownMenu">
                <a data-toggle="tab"
                   :href="`#solarhomePackage${solarhome.id}`"
                   :class="['dropdown-item', {'active': solarhome.id === pickedSolarhomePackageId}]"
                   v-for="(solarhome, index) in promotionPackageList.solarhome"
                   :key="solarhome.id"
                   @click="pickedSolarhomePackageId = solarhome.id"
                >
                  {{ solarhome.name | nullCheck }}
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-9 col-xs-12">
            <div class="tab-content">
              <div v-for="(solarhome, index) in promotionPackageList.solarhome"
                   :key="solarhome.id"
                   :id="`solarhomePackage${solarhome.id}`"
                   :class="['tab-pane', 'fade', {'in': index === 0}, {'active': index === 0}]">
                <div class="tab-pane-header title">{{ solarhome.name | nullCheck }}</div>
                <div class="tab-pane-body">
                  <div class="row">
                    <div :class="[{'col-md-6': solarhome.emptyAdditionalFlag}, {'col-md-4': !solarhome.emptyAdditionalFlag}, 'col-xs-12']">
                      <div class="product">
                        <p class="product-type">패널</p>
                        <div class="product-img">
                          <img v-if="solarhome.module.product_img !== null" :src="solarhome.module.product_img" class="img-responsive" alt="비즈해줌 제품구매 프로모션 패키지 패널 이미지">
                          <img v-else src="~@/assets/img/product/biz-img-shop-module-default.png" class="img-responsive" alt="비즈해줌 제품구매 프로모션 패키지 패널 이미지">
                        </div>
                        <div class="product-logo">
                          <img v-if="solarhome.module.manufacturer.image !== null" :src="solarhome.module.manufacturer.image" class="img-responsive" alt="비즈해줌 제품구매 프로모션 패키지 패널 브랜드 로고">
                        </div>
                        <p class="product-name">{{ solarhome.module.name | nullCheck }} <span v-if="solarhome.module_more_name">{{ solarhome.module_more_name }}</span></p>
                      </div>
                      <div class="desc">
                        <p v-for="desc in solarhome.module.desc">{{ desc | nullCheck }}</p>
                      </div>
                    </div>
                    <div :class="[{'col-md-6': solarhome.emptyAdditionalFlag}, {'col-md-4': !solarhome.emptyAdditionalFlag}, 'col-xs-12']">
                      <div class="product">
                        <p class="product-type">인버터</p>
                        <div class="product-img">
                          <img v-if="solarhome.inverter.product_img !== null" :src="solarhome.inverter.product_img" class="img-responsive product-img" alt="비즈해줌 제품구매 프로모션 패키지 인버터 이미지">
                        </div>
                        <div class="product-logo">
                          <img v-if="solarhome.inverter.manufacturer.image !== null" :src="solarhome.inverter.manufacturer.image" class="img-responsive product-logo" alt="비즈해줌 제품구매 프로모션 패키지 인버터 브랜드 로고">
                        </div>
                        <p class="product-name">{{ solarhome.inverter.name | nullCheck }} <span v-if="solarhome.inverter_more_name">{{ solarhome.inverter_more_name }}</span></p>
                      </div>
                      <div class="desc">
                        <p v-for="desc in solarhome.inverter.desc">{{ desc | nullCheck }}</p>
                      </div>
                    </div>
                    <div v-if="!solarhome.emptyAdditionalFlag" class="col-md-4 col-xs-12 package-plus">
                      <div class="product">
                        <p class="product-type">추가구성</p>
                        <div class="product-img">
                          <img src="~@/assets/svg/ic-package-plus.svg" class="img-responsive">
                          <p>{{ solarhome.additional.category | nullCheck }}</p>
                        </div>
                        <div class="product-logo"></div>
                        <p class="product-name">{{ solarhome.additional.name | nullCheck }}</p>
                      </div>
                      <div class="desc">
                        <p v-for="desc in solarhome.additional.desc">{{ desc | nullCheck }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tab-pane-footer">
                  <button type="button"
                          class="hz-btn-primary hz-btn-lg"
                          @click="showInquiryModal({install_capacity: solarhome.capacity, module: solarhome.module.id, inverter: solarhome.inverter.id, is_promotion: true})"
                  >
                    가격문의
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="calculator">
      <div class="container">
        <h2>직병렬 추천 계산기</h2>
        <p class="description">프로모션 패키지의 설계가능 용량과 <br class="hidden-lg hidden-md hidden-sm">직병렬 조합 정보를 제공합니다.</p>
        <div class="row">
          <div class="col-md-offset-3 col-md-6 col-xs-12">
            <div class="capacity-wrap">
              <label>목표용량 선택</label>
              <div class="row">
                <div class="col-xs-4">
                  <div :class="['box', {'active': calcData.capacity === 100}]" @click="calcData.capacity=100">
                    <div class="circle"></div>
                    <div class="capacity">100kW</div>
                  </div>
                </div>
                <div class="col-xs-4">
                  <div :class="['box', {'active': calcData.capacity === 500}]" @click="calcData.capacity=500">
                    <div class="circle"></div>
                    <div class="capacity">500kW</div>
                  </div>
                </div>
                <div class="col-xs-4">
                  <div :class="['box', {'active': calcData.capacity === 1000}]" @click="calcData.capacity=1000">
                    <div class="circle"></div>
                    <div class="capacity">1000kW</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="product-wrap">
              <a href="#" data-toggle="collapse" data-target="#calcProductList" aria-expanded="false" aria-controls="calcProductList" @click.prevent="openCalcProduct = !openCalcProduct">
                <span class="tag">선택</span>
                패널˙인버터
                <i :class="['glyphicon', {'glyphicon-chevron-down': !openCalcProduct}, {'glyphicon-chevron-up': openCalcProduct}]"></i>
              </a>
              <div id="calcProductList" class="row collapse">
                <div class="col-sm-6 margin-top-16">
                  <label class="category">패널</label>
                  <drop-down-list class="hz-dropdownlist-lg"
                                  :options="moduleList.filter(module => module.use_series_parallel_calculator === true)"
                                  :fields="{'text': 'name', 'value': 'id'}"
                                  v-model="calcData.module">
                  </drop-down-list>
                </div>
                <div class="col-sm-6 margin-top-16">
                  <label class="category">인버터</label>
                  <drop-down-list class="hz-dropdownlist-lg"
                                  :options="inverterList.filter(inverter => inverter.use_series_parallel_calculator === true)"
                                  :fields="{'text': 'name', 'value': 'id'}"
                                  v-model="calcData.inverter">
                  </drop-down-list>
                </div>
              </div>
            </div>
            <div class="text-center" style="padding-top: 24px;">
              <button type="button" class="hz-btn-primary hz-btn-lg" @click="calcSeriesParallel()">계산하기</button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="result" v-if="calculated">
      <div class="container">
        <div class="row">
          <div v-if="calcLoader" class="loader-wrap">
            <div class="loader-content">
              <bar-loader></bar-loader>
            </div>
          </div>
          <div v-show="!calcLoader && parseCalcResults.length === 0" class="empty">
            <p>해당 제품으로 추천하는 직병렬 계산 결과가 없습니다.<br>비즈해줌에서 추천하는 다른 제품 조합을 확인하시겠습니까?</p>
            <button type="button" class="hz-btn-primary hz-btn-lg" @click="reCalculate()">확인하기</button>
          </div>
          <div v-if="parseCalcResults.length > 0" class="col-md-offset-1 col-md-10">
            <ul>
              <li class="row category-list hidden-xs">
                <div class="col-xs-4 category">설계가능용량</div>
                <div class="col-xs-2 category">직렬×병렬</div>
                <div class="col-xs-2 category">패널˙인버터</div>
                <div class="col-xs-2 category">개수</div>
              </li>
              <li class="row card" v-for="(calc, $index) in parseCalcResults[0]" :key="calc.id">
                <div class="card-header col-md-4 col-xs-12">
                  <div class="orange-tag">추천 {{ $index + 1 }}위</div>
                  <div class="category">설계가능용량</div>
                  <div class="capacity">{{ calc.final_capacity | nullCheck }} kW</div>
                </div>
                <div class="card-body col-md-6 col-xs-12">
                  <div class="category">직렬x병렬</div>
                  <div class="row panel-wrap">
                    <div class="col-md-4">
                      <div class="combination">{{ calc.mix_1 | nullCheck }} <small v-if="calc.mix_1_count > 0">{{ calc.mix_1_count | nullCheck }}대 연결</small></div>
                    </div>
                    <div class="col-md-4">
                      <div class="category">패널</div>
                      <div class="name">{{ calc.module_name | nullCheck }}</div>
                    </div>
                    <div class="col-md-4">
                      <div class="count">{{ calc.module_count | nullCheck }}EA</div>
                    </div>
                  </div>
                  <div class="row inverter-wrap">
                    <div class="col-md-4">
                      <div class="combination">{{ calc.mix_2 | nullCheck }} <small v-if="calc.mix_2_count > 0">{{ calc.mix_2_count | nullCheck }}대 연결</small></div>
                    </div>
                    <div class="col-md-4">
                      <div class="category">인버터</div>
                      <div class="name">{{ calc.inverter_name | nullCheck }}</div>
                    </div>
                    <div class="col-md-4">
                      <div class="count">{{ calc.inverter_count | nullCheck }}EA</div>
                    </div>
                  </div>
                </div>
                <div class="card-footer col-md-2 col-xs-12">
                  <button type="button" class="hz-btn-default hz-btn-md"
                          @click="showInquiryModal({install_capacity: calc.target_capacity, module: calc.module, inverter: calc.inverter})">문의</button>
                </div>
              </li>
            </ul>
            <ul v-if="parseCalcResults.length > 1" id="calcMoreResults" class="collapse">
              <li class="row card" v-for="(calc, $index) in parseCalcResults[1]" :key="calc.id">
                <div class="card-header col-md-4 col-xs-12">
                  <div class="orange-tag">추천 {{ $index + 4 }}위</div>
                  <div class="category">설계가능용량</div>
                  <div class="capacity">{{ calc.final_capacity | nullCheck }} kW</div>
                </div>
                <div class="card-body col-md-6 col-xs-12">
                  <div class="category">직렬x병렬</div>
                  <div class="row panel-wrap">
                    <div class="col-md-4">
                      <div class="combination">{{ calc.mix_1 | nullCheck }} <small v-if="calc.mix_1_count > 0">{{ calc.mix_1_count | nullCheck }}대 연결</small></div>
                    </div>
                    <div class="col-md-4">
                      <div class="category">패널</div>
                      <div class="name">{{ calc.module_name | nullCheck }}</div>
                    </div>
                    <div class="col-md-4">
                      <div class="count">{{ calc.module_count | nullCheck }}EA</div>
                    </div>
                  </div>
                  <div class="row inverter-wrap">
                    <div class="col-md-4">
                      <div class="combination">{{ calc.mix_2 | nullCheck }} <small v-if="calc.mix_2_count > 0">{{ calc.mix_2_count | nullCheck }}대 연결</small></div>
                    </div>
                    <div class="col-md-4">
                      <div class="category">인버터</div>
                      <div class="name">{{ calc.inverter_name | nullCheck }}</div>
                    </div>
                    <div class="col-md-4">
                      <div class="count">{{ calc.inverter_count | nullCheck }}EA</div>
                    </div>
                  </div>
                </div>
                <div class="card-footer col-md-2 col-xs-12">
                  <button type="button" class="hz-btn-default hz-btn-md"
                          @click="showInquiryModal({install_capacity: calc.target_capacity, module: calc.module, inverter: calc.inverter})">문의</button>
                </div>
              </li>
            </ul>
            <div class="notice"><img src="~@/assets/svg/ic-exclamation-yellow.svg">직병렬 추천 계산기 결과는 참고용으로만 사용하기 바랍니다.</div>
            <div v-if="parseCalcResults.length > 1" class="more text-center">
              <a href="#" data-toggle="collapse" data-target="#calcMoreResults" aria-expanded="false" aria-controls="calcMoreResults" @click.prevent="openCalcResult = !openCalcResult">
                <i :class="['glyphicon', {'glyphicon-chevron-down': !openCalcResult}, {'glyphicon-chevron-up': openCalcResult}]"></i>
                {{ openCalcResultText }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="brochure">
      <div class="container">
        <div class="row">
          <h2>자료 다운로드</h2>
          <div class="col-md-offset-4 col-md-4">
            <div class="text-center margin-bottom-8">
              <div class="radio-btn-group">
                <div class="radio-btn-group-item">
                  <input type="radio" id="module" name="module" value="module" v-model="pickedManufacturerType">
                  <label for="module">패널</label>
                </div>
                <div class="radio-btn-group-item">
                  <input type="radio" id="inverter" name="inverter" value="inverter" v-model="pickedManufacturerType">
                  <label for="inverter">인버터</label>
                </div>
              </div>
            </div>
            <div class="margin-bottom-32">
              <label class="category">제품 선택</label>
              <drop-down-list class="hz-dropdownlist-lg margin-bottom-16"
                              :label="'제조사 선택'"
                              :options="pickedTypeManufacturerList"
                              :fields="{'text': 'name', 'value': 'id'}"
                              v-model="pickedManufacturerID">
              </drop-down-list>
              <drop-down-list class="hz-dropdownlist-lg"
                              :label="'모델 선택'"
                              :options="brochureProductList"
                              :fields="{'text': 'name', 'value': 'id'}"
                              v-model="pickedProductID">
              </drop-down-list>
            </div>
            <div>
              <label class="category">다운로드 선택</label>
              <ul class="row">
                <li class="col-xs-4 checkbox"
                    v-for="check in checkboxList"
                    :key="check.id">
                  <label :class="{'disabled': !brochureList[check.id]}">
                    <input type="checkbox" :value="check.id" v-model="checkedBrochureList" :disabled="!brochureList[check.id]">
                    <span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span>
                    {{ check.name }}
                  </label>
                </li>
              </ul>
            </div>
            <div class="text-center">
              <a id="downloadBrochure" :href="downloadBrochureUrl" style="display: none;"></a>
              <button type="button"
                      :class="['hz-btn-primary', 'hz-btn-lg', {'hz-btn-disabled': checkedBrochureList.length === 0}]"
                      :title="downloadBrochureBtnText"
                      @click="downloadBrochure()">다운로드</button>
            </div>
          </div>
        </div>
      </div>
    </section>
    

    <section id="manufacturer">
      <div class="container">
        <h4 class="sub-title">함께하는 제조사</h4>
        <ul class="row">
          <li class="col-md-2 col-xs-4"><img src="/media/shop/product/1_hd.png" class="img-responsive logo"></li>
          <li class="col-md-2 col-xs-4"><img src="/media/shop/product/2_hws.png" class="img-responsive logo"></li>
          <li class="col-md-2 col-xs-4"><img src="/media/shop/product/3_S-energy.png" class="img-responsive logo"></li>
          <li class="col-md-2 col-xs-4"><img src="/media/shop/product/4_Jinko.png" class="img-responsive logo"></li>
          <li class="col-md-2 col-xs-4"><img src="/media/shop/product/5_JAsolar.png" class="img-responsive logo"></li>
          <li class="col-md-2 col-xs-4"><img src="/media/shop/product/6_risen.png" class="img-responsive logo"></li>
          <li class="col-md-2 col-xs-4"><img src="/media/shop/product/7_Trinasolar.png" class="img-responsive logo"></li>
          <li class="col-md-2 col-xs-4"><img src="/media/shop/product/8_gb.png" class="img-responsive logo"></li>
          <li class="col-md-2 col-xs-4"><img src="/media/shop/product/9_dasstech.png" class="img-responsive logo"></li>
          <li class="col-md-2 col-xs-4"><img src="/media/shop/product/10_Growatt.png" class="img-responsive logo"></li>
          <li class="col-md-2 col-xs-4"><img src="/media/shop/product/11_Solis.png" class="img-responsive logo"></li>
          <li class="col-md-2 col-xs-4"><img src="/media/shop/product/12_hs.png" class="img-responsive logo"></li>
        </ul>
      </div>
    </section>
    <section id="contact">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <h3>기자재 구매 문의</h3>
            <h2>010-6233-9941</h2>
            <p class="pc-memo">상담시간 : 평일 9시~18시(주말, 공휴일, 대체휴일 제외)</p>
            <p class="m-memo">상담시간 : 평일 9시~18시<br>(주말, 공휴일, 대체휴일 제외)</p>
          </div>
        </div>
      </div>
    </section>
    <section id="applyList" v-if="user.id">
      <div class="container">
        <h4 class="sub-title">신청목록</h4>
        <div class="row">
          <div class="col-xs-12 padding-0">
            <kendo-grid ref="grid"
                        :columns="tableFields"
                        :options="tableOptions"
                        :data-url="dataUrl + '/biz/buy/product/'"
                        :auth="true"
                        :message="'신청내역이 없습니다.'">
            </kendo-grid>
          </div>
        </div>
      </div>
    </section>
    <!-- 알림창 -->
    <modal ref="notifyModal" :id="notifyModal.id" :type="notifyModal.type" :title="notifyModal.title" :size="notifyModal.size" :fields="notifyModal.fields"></modal>
    <!-- 구매문의창 -->
    <div id="inquiryModal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content" style="max-width: 550px; margin: auto;">
          <div class="modal-header">
            <h5 style="margin: 0">제품구매 가격문의</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form class="modal-body">
            <div class="form-group margin-bottom-16">
              <label class="modal-label col-sm-4">패널</label>
              <div class="modal-input col-sm-8">
                <drop-down-list class="hz-dropdownlist-md"
                                :options="moduleList"
                                :readonly="inquiryData.is_promotion"
                                :fields="{'text': 'name', 'value': 'id'}"
                                v-model="inquiryData.module">
                </drop-down-list>
              </div>
            </div>
            <div class="row form-group margin-bottom-16">
              <label class="modal-label col-sm-4">인버터</label>
              <div class="modal-input col-sm-8">
                <drop-down-list class="hz-dropdownlist-md"
                                :options="inverterList"
                                :readonly="inquiryData.is_promotion"
                                :fields="{'text': 'name', 'value': 'id'}"
                                v-model="inquiryData.inverter">
                </drop-down-list>
              </div>
            </div>
            <div class="row require-text">*필수입력사항</div>
            <div class="row form-group">
              <label class="modal-label col-sm-4">총용량<span class="require-tag">*</span></label>
              <div class="modal-input col-sm-8">
                <input-float class="hz-input-default hz-input-md input-spin-none"
                             :size="2"
                             data-vv-name="totalCapacity"
                             v-validate="{required: true, min_value: 1}"
                             v-model="inquiryData.install_capacity" />
                <span class="hz-unit">kWp</span>
                <p class="is-invalid-text">{{ errors.first('totalCapacity') }}</p>
              </div>
            </div>
            <div class="form-group">
              <label class="modal-label col-sm-4">문의사항</label>
              <div class="modal-input col-sm-8">
                <textarea class="text-area hz-input-default" rows="5" placeholder="문의내용을 적어주세요." v-model="inquiryData.etc"></textarea>
              </div>
            </div>
            <div class="text-center">
              <button type="button" class="hz-btn-primary hz-btn-lg margin-bottom-24" @click="validate">문의신청</button>
            </div>
          </form>
          <div class="modal-footer">담당자가 영업일 3일내 연락드립니다.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import api from '@/api/index'
  import Carousel from '@/components/Carousel'
  import KendoGrid from 'common/components/KendoGrid'
  import Modal from 'common/components/Modal'
  import DropDownList from 'common/components/DropDownList'
  import InputFloat from 'common/components/InputFloat'
  import Loader from 'common/components/Loader'
  import BarLoader from 'common/components/BarLoader'
  import { mapActions, mapGetters } from 'vuex'
  import eventHub from '@/shared/EventHub'

  export default {
    name: 'product',
    components: {
      Carousel,
      KendoGrid,
      Modal,
      DropDownList,
      InputFloat,
      Loader,
      BarLoader
    },
    data () {
      return {
        dataUrl: location.protocol + '//' + location.hostname.replace('biz', 'api'),
        downloadBrochureUrl: '',
        promotionDetailPath: '',
        pickedRpsPackageId: '',
        pickedSolarhomePackageId: '',
        pickedManufacturerType: 'module',
        pickedManufacturerID: '',
        pickedProductID: '',
        bannerIndex: 0,
        currentSlide: 1,
        totalSlide: 0,
        windowWidth: 0,
        loaderActive: false,
        calculated: false,
        calcLoader: false,
        openCalcProduct: false,
        openCalcResult: false,
        openManufacturer: false,
        bannerList: [],
        recommendList: [],
        promotionPackageList: {
          rps: [],
          solarhome: []
        },
        moduleList: [],
        inverterList: [],
        manufacturerList: [],
        manufacturerProductList: {
          module: [],
          inverter: []
        },
        checkedBrochureList: [],
        checkboxList: [
          { id: 'ks_certificate', name: 'KS인증서' },
          { id: 'install_manual', name: '설치매뉴얼' },
          { id: 'test_report', name: '시험성적서' },
          { id: 'quality_assurance', name: '품질보증서' },
          { id: 'specifications', name: '사양서' },
          { id: 'floor_plan', name: '도면모음' }
        ],
        calcResults: [],
        tableFields: [
          {
            field: 'reg_date',
            title: '신청일자',
            type: 'date',
            format: '{0:yyyy.MM.dd}',
            width: '120px',
            sortable: false,
            filterable: false
          },
          {
            field: 'module__name',
            title: '패널',
            type: 'string',
            width: '140px',
            sortable: false,
            filterable: false,
            template: function (item) {
              return item.module__name === '' ? '-' : item.module__name
            }
          },
          {
            field: 'inverter__name',
            title: '인버터',
            type: 'string',
            width: '140px',
            sortable: false,
            filterable: false,
            template: function (item) {
              return item.inverter__name === '' ? '-' : item.inverter__name
            }
          },
          {
            field: 'install_capacity',
            title: '총용량 (kW)',
            type: 'number',
            width: '120px',
            sortable: false,
            filterable: false
          },
          {
            field: 'step',
            title: '진행상황',
            type: 'string',
            width: '120px',
            sortable: false,
            filterable: false
          }
        ],
        tableOptions: {
          pageable: {
            info: true,
            previousNext: true,
            numeric: true,
            pageSize: 50,
            pageSizes: [20, 50, 100, 'all'],
            refresh: true,
            buttonCount: 5,
            messages: {
              itemsPerPage: '페이지당 항목수'
            }
          }
        },
        calcData: {
          capacity: 0,
          module: '',
          inverter: ''
        },
        inquiryData: {
          module: '',
          inverter: '',
          install_capacity: 0,
          etc: '',
          is_promotion: false
        },
        notifyModal: {
          id: 'notifyModal',
          type: 'alert',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: [],
              class: 'text-center'
            }
          ]
        }
      }
    },
    computed: {
      ...mapGetters({
        user: 'user'
      }),
      pageText () {
        return `${this.currentSlide} / ${this.totalSlide}`
      },
      selectedRpsPackageName () {
        const id = this.pickedRpsPackageId
        let name = '선택해주세요.'
        if (id) {
          const target = this.promotionPackageList.rps.find(x => x.id === id)
          name = target.name
        }

        return name
      },
      selectedSolarhomePackageName () {
        const id = this.pickedSolarhomePackageId
        let name = '선택해주세요.'
        if (id) {
          const target = this.promotionPackageList.solarhome.find(x => x.id === id)
          name = target.name
        }

        return name
      },
      showBannerControl () {
        const isNotSingleBanner = this.bannerList.length > 1
        const isNotMobile = this.windowWidth > 767

        return isNotSingleBanner > 0 && isNotMobile
      },
      openCalcResultText () {
        return this.openCalcResult ? '닫기' : '더보기'
      },
      parseCalcResults () {
        let data = _.cloneDeep(this.calcResults)

        if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            data[i].module_name = this.findProductName(data[i].module, this.moduleList)
            data[i].inverter_name = this.findProductName(data[i].inverter, this.inverterList)
          }

          data = _.chunk(data, 3)
        }

        return data
      },
      openManufacturerText () {
        return this.openManufacturer ? '닫기' : '더보기'
      },
      divisionManufacturerList () {
        return _.chunk(_.cloneDeep(this.manufacturerList), 12)
      },
      pickedTypeManufacturerList () {
        return this.manufacturerProductList[this.pickedManufacturerType]
      },
      brochureProductList () {
        // 선택된 제조사 ID 값을 비교하여 제품 목록을 반환
        let list = []
        const id = parseInt(this.pickedManufacturerID)

        if (id) {
          const type = this.pickedManufacturerType
          const productList = this.pickedTypeManufacturerList
          const findList = productList.find(item => { return item.id === id })

          list = findList[type]
        }

        return list
      },
      brochureList () {
        // 선택된 제품 ID 값을 비교하여 브로슈어 정보를 반환
        let brochure = {
          ks_certificate: null,
          install_manual: null,
          test_report: null,
          quality_assurance: null,
          specifications: null,
          floor_plan: null
        }
        const productID = parseInt(this.pickedProductID)
        const productList = this.brochureProductList

        if (productList.length > 0 && productID) {
          brochure = productList.find(product => { return product.id === productID })
        }

        return brochure
      },
      downloadBrochureBtnText () {
        return this.checkedBrochureList.length > 0 ? '선택된 제품 브로슈어를 다운로드 합니다.' : '선택된 제품 브로슈어가 없습니다.'
      }
    },
    watch: {
      pickedManufacturerType () {
        this.pickedManufacturerID = ''
        this.pickedProductID = ''
        this.checkedBrochureList = []
      },
      pickedManufacturerID () {
        this.pickedProductID = ''
      },
      brochureList (val) {
        // 선택된 제품에 따라 브로셔 활성 여부를 설정한다.
        this.checkedBrochureList = this.setBrochureCheckBox(val)
      }
    },
    methods: {
      ...mapActions([
        'showToastMessage'
      ]),
      applyProduct () {
        axios.post('/biz/buy/product/', this.inquiryData)
          .then(response => {
            this.loaderActive = false
            this.showToastMessage('신청완료')
            this.$refs.grid.refresh()
            this.scrollTo({link: '#applyList'})
          })
          .catch(e => {
            this.loaderActive = false
            this.showToastMessage('신청실패')
          })
      },
      clickBanner (params) {
        const link = params.link
        if (link.charAt(0) === '#') {
          this.scrollTo({link: link})
        } else if (link.charAt(0) === '?') {
          const query = Object.fromEntries(new URLSearchParams(link))
          this.setDefaultPackage(query.name)
        }
      },
      calcSeriesParallel () {
        // 로그인을 하지 않았을 경우, 로그인 알림창을 띄운다.
        if (!this.user.isLogin) {
          eventHub.$emit('showLoginModal')
          return false
        }

        const data = this.calcData
        if (data.capacity === 0) {
          this.notifyModal.fields[0].message = ['목표용량을 선택해주세요.']
          this.$refs.notifyModal.show()
          return false
        }

        // 직병렬 계산 결과값 영역 활성화를 위해 API 최초 실행 시 true 할당
        if (!this.calculated) {
          this.calculated = true
        }

        this.calcLoader = true
        this.calcResults = []

        // API 호출
        const query = `?target_capacity=${data.capacity}&module=${data.module}&inverter=${data.inverter}`
        axios.get(`/biz/series-parallel-calculator/${query}`)
          .then(response => {
            this.calcResults = response.data
            this.openCalcResult = false
            this.calcLoader = false

            // 결과값 영역으로 스크롤 이동
            const offset = window.innerWidth < 767 ? 64 : 154
            this.scrollTo({link: '#result'}, offset)
          })
          .catch(e => {
            this.calcLoader = false
            this.showToastMessage('직병렬 계산 실패')
          })
      },
      downloadRecommendBrochure () {
        // 로그인을 하지 않았을 경우, 로그인 알림창을 띄운다.
        if (!this.user.isLogin) {
          eventHub.$emit('showLoginModal')
          return false
        }

        // 선택된 추천제품 타입에 따라 제조사 초기화 후 자료다운로드 영역으로 스크롤 이동
        const activeItem = $('#recommendCarousel .item.active')
        const productType = activeItem.attr('data-product-type')
        const manufacturerName = activeItem.attr('data-manufacturer-name')
        const targetManufacturer = this.manufacturerProductList[productType].find(item => item.name === manufacturerName)

        this.pickedManufacturerType = productType

        this.$nextTick(() => {
          this.pickedManufacturerID = targetManufacturer.id
          this.scrollTo({link: '#brochure'})
        })
      },
      downloadBrochure () {
        // 로그인을 하지 않았을 경우, 로그인 알림창을 띄운다.
        if (!this.user.isLogin) {
          eventHub.$emit('showLoginModal')
          return false
        }

        const id = this.pickedProductID
        const type = this.pickedManufacturerType
        const brochureList = this.checkedBrochureList.toString()
        // 선택된 브로셔 목록이 있을 경우 실행
        if (brochureList) {
          // 다운로드 url 설정 후 a 태그 클릭 이벤트를 실행시켜 다운로드 한다.
          this.downloadBrochureUrl = `${this.dataUrl}/biz/sell/product/brochure_download/?id=${id}&type=${type}&brochure_list=${brochureList}`
          this.$nextTick(() => {
            document.getElementById('downloadBrochure').click()
          })
        }
      },
      findProductName (id = '', list = []) {
        const module = _.find(list, (o) => {
          return o.id === id
        })

        return module ? module.name : '-'
      },
      getBanner () {
        api.getBanner('product', response => {
          if (response.error) {
            this.showToastMessage('배너목록 불러오기 실패')
          } else {
            this.bannerList = response
            this.totalSlide = response.length

            // 쿼리스트링에 전달받은 배너 인덱스 값이 있을 경우, 해당 인덱스로 초기화한다.
            const index = parseInt(this.$route.query.banner_index)
            if (index) {
              this.bannerIndex = index - 1
              this.currentSlide = index
            }

            // add Event slide Page Count
            this.$nextTick(() => {
              const bannerCarousel = $('#bannerCarousel')
              bannerCarousel.on('slid.bs.carousel', () => {
                this.currentSlide = bannerCarousel.find('.item.active').index() + 1
              })
            })
          }
        })
      },
      getRecommend () {
        // 추천제품 받아오기
        axios.get('/biz/sell/product/recommend/')
          .then(response => {
            this.recommendList = response.data
          })
          .catch(e => {
            this.showToastMessage('추천제품 목록 불러오기 실패')
          })
      },
      getPromotionPackage () {
        axios.get('/biz/sell/product/')
          .then(response => {
            const rps = response.data.rps
            const solarhome = response.data.solarhome

            // 추가 패키지 구성여부 플래그를 추가해준다.
            this.promotionPackageList = {
              rps: rps.map((item) => {
                item.emptyAdditionalFlag = _.isEmpty(item.additional)
                return item
              }),
              solarhome: solarhome.map((item) => {
                item.emptyAdditionalFlag = _.isEmpty(item.additional)
                return item
              })
            }

            this.$nextTick(() => {
              // 선택된 RPS, 주택용 패키지 ID 값 초기화
              this.pickedRpsPackageId = rps.length > 0 ? rps[0].id : ''
              this.pickedSolarhomePackageId = solarhome.length > 0 ? solarhome[0].id : ''

              // URL 쿼리로 전달받은 패키지명이 있을 경우 실행
              const query = this.$route.query
              if (query.hasOwnProperty('name')) {
                this.setDefaultPackage(query.name)
              }

              // 패키지 드롭다운 이벤트
              $('.package-dropdown').on('shown.bs.dropdown', function (e) {
                const icon = e.target.children[0].children[0]
                icon.classList.replace('glyphicon-chevron-down', 'glyphicon-chevron-up')
              })
              $('.package-dropdown').on('hidden.bs.dropdown', function (e) {
                const icon = e.target.children[0].children[0]
                icon.classList.replace('glyphicon-chevron-up', 'glyphicon-chevron-down')
              })
            })
          })
          .catch(e => {
            this.showToastMessage('프로모션 목록 불러오기 실패')
          })
      },
      // getManufacturer () {
      //   axios.get('/biz/sell/product/manufacturer/')
      //     .then(response => {
      //       this.manufacturerList = response.data
      //     })
      //     .catch(e => {
      //       this.showToastMessage('제조사 목록 불러오기 실패')
      //     })
      // },
      // getManufacturerModule () {
      //   axios.get('/biz/sell/product/manufacturer_module/')
      //     .then(response => {
      //       this.manufacturerProductList.module = response.data
      //     })
      //     .catch(e => {
      //       this.showToastMessage('제조사별 패널 목록 불러오기 실패')
      //     })
      // },
      // getManufacturerInverter () {
      //   axios.get('/biz/sell/product/manufacturer_inverter/')
      //     .then(response => {
      //       this.manufacturerProductList.inverter = response.data
      //     })
      //     .catch(e => {
      //       this.showToastMessage('제조사별 인버터 목록 불러오기 실패')
      //     })
      // },
      // getModule () {
      //   axios.get('/biz/sell/product/module/')
      //     .then(response => {
      //       this.moduleList = response.data
      //     })
      //     .catch(e => {
      //       this.showToastMessage('패널 목록 불러오기 실패')
      //     })
      // },
      // getInverter () {
      //   axios.get('/biz/sell/product/inverter/')
      //     .then(response => {
      //       this.inverterList = response.data
      //     })
      //     .catch(e => {
      //       this.showToastMessage('인버터 목록 불러오기 실패')
      //     })
      // },
      onResize () {
        this.windowWidth = window.innerWidth
      },
      reCalculate () {
        // 직병렬 계산 추천 결과값이 없을 경우, 제품 초기화 후 계산 재요청
        this.calcData.module = ''
        this.calcData.inverter = ''
        this.calcSeriesParallel()
      },
      scrollTo (data, offset = 64) {
        if (data.link) {
          const el = $(data.link)
          if (el) {
            const position = el.offset().top - offset
            $('html,body').stop().animate({scrollTop: (position)}, 500)
          }
        }
      },
      setBrochureCheckBox (data) {
        // 브로셔 유무에 따른 체크박스 값 할당
        let list = []
        const checkList = ['ks_certificate', 'install_manual', 'test_report', 'quality_assurance', 'specifications', 'floor_plan']
        for (let i in checkList) {
          const brochure = checkList[i]
          if (data[brochure] !== null) {
            list.push(brochure)
          }
        }

        return list
      },
      setDefaultPackage (name = '') {
        // URL 쿼리로 전달받은 패키지명이 있을 경우, 스크롤 이동 & 기본 출력 화면을 설정한다.
        const tabs = this.$el.querySelectorAll('.nav-stacked a')
        const targetTab = _.find(tabs, item => item.text === name)

        if (targetTab) {
          // 탭 ID 설정
          const type = targetTab.getAttribute('data-type')
          if (type === 'rps') {
            this.pickedRpsPackageId = parseInt(targetTab.getAttribute('data-id'))
          } else {
            this.pickedSolarhomePackageId = parseInt(targetTab.getAttribute('data-id'))
          }

          // 탭 화면 출력
          $(targetTab).tab('show')

          // 스크롤 이동
          const scrollTarget = type === 'rps' ? '#rpsPackage' : '#solarhomePackage'
          this.scrollTo({link: scrollTarget})
        }
      },
      showInquiryModal (data = {}) {
        // 로그인을 하지 않았을 경우, 로그인 알림창을 띄운다.
        if (!this.user.isLogin) {
          eventHub.$emit('showLoginModal')
          return false
        }

        this.inquiryData = Object.assign(this.inquiryData, data)

        // 제품구매 신청창을 띄운다.
        $('#inquiryModal').modal('show')
      },
      validate () {
        this.$validator.validateAll()

        this.$nextTick(() => {
          if (!this.errors.any()) {
            this.loaderActive = true
            this.applyProduct()
            $('#inquiryModal').modal('hide')
          }
        })
      }
    },
    created () {
      this.getBanner()
      this.getRecommend()
      this.getPromotionPackage()
      // this.getManufacturer()
      // this.getManufacturerModule()
      // this.getManufacturerInverter()
      // this.getModule()
      // this.getInverter()
      this.onResize()
    },
    mounted () {
      // // 추천제품 Carousel 이벤트 리스너
      // const recommendCarousel = $('#recommendCarousel')
      // recommendCarousel.on('slid.bs.carousel', () => {
      //   this.pickedRecommendManufacturer = recommendCarousel.find('.item.active').attr('data-manufacturer')
      // })

      // Modal 이벤트 리스너
      $('#inquiryModal').on('hidden.bs.modal', () => {
        this.inquiryData = {
          module: '',
          inverter: '',
          install_capacity: 0,
          etc: '',
          is_promotion: false
        }
        // v-validate error 초기화
        this.errors.clear()
      })

      // resize 이벤트 리스너
      window.addEventListener('resize', this.onResize)

      // URL 쿼리에 section 값이 있고, 기본 설정할 패키지명이 없을 경우 해당 영역으로 스크롤 이동
      const query = this.$route.query
      if (query.hasOwnProperty('section') && !query.hasOwnProperty('name')) {
        setTimeout(() => {
          this.scrollTo({ link: `#${query.section}` })
        }, 1500)
      }
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.onResize)
    }
  }
</script>

<style>
  a:-webkit-any-link {
      cursor: default !important;
  }
</style>

<style lang="scss" scoped>
  #product {
    word-break: keep-all;
    ul { padding: 0; }
    ul li { list-style: none }
    button { width: 167px }

    .container {
      @media (max-width: $screen-xs-max) {
        padding: 0 8px;
      }
    }

    section {
      padding: 90px 0;

      @media (max-width: $screen-xs-max) {
        padding: 60px 0;
      }
    }


    h2 {
      margin: 0 0 16px;
      font-size: 40px;
      font-weight: bold;
      line-height: 1.25;
      letter-spacing: -2.42px;
      text-align: center;
      color: $header-color;

      @media (max-width: $screen-xs-max) {
        font-size: 32px;
      }
    }

    .sub-title {
      margin: 0 0 40px;
      padding: 0 16px;
      font-size: 22px;
      font-weight: bold;
      line-height: 1.18;
      letter-spacing: -1.1px;
      color: $font-color;
    }

    .description {
      margin: 0 0 40px;
      font-size: 20px;
      line-height: 1.4;
      letter-spacing: -0.8px;
      text-align: center;
      color: $blue-grey;

      @media (max-width: $screen-xs-max) {
        font-size: 16px;
      }
    }

    .category {
      padding: 0;
      font-size: 14px;
      font-weight: bold;
      line-height: 1.43;
      letter-spacing: -0.35px;
      color: $blue-grey;
    }

    #banner {
      padding: 52px 0 0;

      .hz-carousel-page {
        display: none;
        position: absolute;
        right: 16px;
        bottom: 16px;
        width: 48px;
        height: 22px;
        border-radius: 11px;
        background-color: rgba(0, 0, 0, 0.3);
        font-size: 12px;
        line-height: 22px;
        letter-spacing: -0.3px;
        color: $hzc-white;
        text-align: center;
      }

      @media (max-width: $screen-xs-max) {
        padding: 0;
        .container, .col-xs-12 {
          padding: 0;
        }
      }
    }

    #benefit {
      display: none;
      .orange-tag {
        margin-bottom: 8px;
        font-size: 16px;
        font-weight: bold;
        line-height: 1.5;
        letter-spacing: -1.3px;
        text-align: center;
        color: $orange;
      }

      .box {
        display: table;
        width: 100%;
        margin-bottom: 8px;
        padding: 18px 24px;
        border-radius: 4px;
        background-color: $grey;
      }

      .box .icon {
        display: table-cell;
        vertical-align: middle;
      }

      .box .desc {
        display: table-cell;
        vertical-align: middle;
        padding-left: 24px;
      }

      .box .desc p {
        margin-bottom: 8px;
        font-size: 16px;
        font-weight: bold;
        line-height: 1.5;
        letter-spacing: -0.7px;
        color: $font-color;
      }

      .box .desc span {
        font-size: 12px;
        line-height: 1.33;
        letter-spacing: -0.3px;
        color: $blue-grey;
      }

      @media (max-width: 1199px) {
        .box .desc {
          padding-left: 16px;
        }
      }
    }

    #recommend {
      .img-product {
        height: 339px;
      }

      .brand-logo {
        margin: 0 0 24px;
      }

      ul li {
        position: relative;
        padding: 0 0 0 32px;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 2.38;
        letter-spacing: -0.7px;
        color: $font-color;
      }

      ul li:before {
        position: absolute;
        left: 0;
        top: 13px;
        content: "";
        width: 16px;
        height: 12px;
        background: url('~@/assets/svg/ic-check-purple.svg');
        background-size: 16px 12px;
      }

      .carousel {
        margin-bottom: 52px;
        padding: 40px 0 0;
      }

      .item {
        min-height: 380px;

        @media (max-width: $screen-md-max) {
          min-height: 420px;
        }

        @media (max-width: $screen-sm-max) {
          margin: 4px;
          padding: 16px;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
        }

        @media (max-width: 348px) {
          min-height: 440px;
        }
      }

      .text-center button {
        margin: 0 8px;
      }

      @media (max-width: $screen-xs-max) {
        padding-left: 8px;
        padding-right: 8px;

        .description {
          margin: 0 0 24px;
        }

        .brand-logo {
          margin: 0;
        }

        .carousel {
          padding: 16px 0;
        }

        .active .col-xs-12 {
          padding: 0;
        }

        .carousel ul li {
          font-size: 14px;
          line-height: 2.21;
          letter-spacing: -0.58px;
        }

        .text-center button {
          width: calc(50% - 10px);
          margin: 0 4px;
        }
      }
    }

    #promotion {
      h4 {
        margin: 0 0 24px;
      }

      .container >.row {
        margin: 0 0 60px;
      }

      .title {
        font-size: 26px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.31;
        letter-spacing: -1px;
        text-align: center;
        color: $font-color;
        @media (max-width: $screen-sm-max) {
          font-size: 20px;
        }
      }

      .dropdown-toggle,
      .dropdown-menu {
        width: 100%;
        border-radius: 4px;
        box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.09);
        border: solid 1px $border-color;
      }

      .dropdown-toggle,
      .dropdown-item {
        display: block;
        padding: 14px 16px;
        background: $hzc-white;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: -0.35px;
        color: $font-color;
        text-align: left;
        text-decoration: none;
      }

      .dropdown-toggle i {
        top: 5px;
        font-size: 12px;
        color: $blue-grey;
        float: right;
      }

      .dropdown-item.active {
        background-color: #f5f2fc;
        color: $purple;
      }

      .nav li a {
        margin: 0 0 24px;
        padding: 13px 0;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.31;
        letter-spacing: normal;
        text-align: center;
        color: $blue-grey;
        cursor: pointer;
      }

      .nav li a:focus {
        background-color: initial;
      }

      .nav li.active a,
      .nav li a:hover {
        border-radius: 20.5px;
        background-color: #f5f2fc;
        color: $purple;
        outline: none;
      }

      .tab-content {
        border-radius: 4px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        border: solid 1px $hzc-gray-03;
        background-color: $hzc-white;
        text-align: center;
      }

      .tab-pane-header {
        padding: 32px 16px;

        @media (max-width: $screen-sm-max) {
          padding: 24px 16px;
        }
      }

      .tab-pane-body {
        padding: 32px 16px;
        border-width: 1px 0;
        border-style: solid;
        border-color: $hzc-gray-02;

        @media (max-width: $screen-sm-max) {
          padding: 24px 16px;
        }

        p {
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: -0.7px;
          text-align: center;
          color: $font-color;
        }

        .product-type {
          margin: 0 0 8px;
          font-weight: bold;
        }

        .product-img {
          height: 167px;
          margin: 0 auto 16px;

          img {
            max-height: 167px;
            margin: auto;
          }

          @media (max-width: $screen-sm-max) {
            display: none;
          }
        }

        .product-logo {
          height: 41px;
          margin: 0 auto 8px;

          img {
            max-height: 41px;
            margin: auto;
          }
        }

        .product-name {
          margin: 0;
          font-size: 14px;
          line-height: 1.57;
          letter-spacing: -0.58px;
          text-align: center;
          color: $blue-grey;
        }

        .desc {
          position: relative;
          margin: 16px 0 0;

          p {
            margin: 0;
            padding: 16px 0 16px 16px;
          }

          p::before {
            position: absolute;
            left: 0;
            content:  url('~@/assets/svg/ic-check-gray.svg');
          }

          p:not(:first-child) {
            border-top: 1px solid $hzc-gray-03;
          }

          @media (max-width: $screen-sm-max) {
            p {
              padding: 8px 0;
              border: 0 !important;
            }
          }
        }
      }

      .tab-pane-footer {
        padding: 32px 16px;
        background-color: $light-grey;

        button {
          width: 260px;
        }
      }

      .package-plus {
        .product-img {
          padding: 32px 0 0;
          background-color: $light-grey;
        }

        .product-img p {
          margin: 32px 0 0;
          font-size: 14px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.43;
          letter-spacing: -0.35px;
          text-align: center;
          color: $font-color;
        }

        @media (max-width: $screen-sm-max) {
          .product-img {
            display: block;
            height: auto;
            padding: 12px 0;
          }

          .product-img img {
            display: none;
          }

          .product-img p{
            margin: 0;
          }

          .product-logo {
            display: none;
          }
        }
      }

      @media (max-width: $screen-sm-max) {
        .col-md-3 {
          margin: 0 0 24px;
          padding: 24px 8px;
          background-color: $light-grey;
        }

        .col-md-4:not(:last-child),
        .col-md-6:not(:last-child) {
          margin: 0 0 60px;
        }
      }
    }

    #calculator {
      display: none;
      .capacity-wrap {
        margin-bottom: 32px;

        label {
          margin: 0 0 16px;
          font-size: 16px;
          font-weight: bold;
          line-height: 1.5;
          letter-spacing: -0.7px;
          color: $header-color;
        }

        .box {
          position: relative;
          border-radius: 4px;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
          background-color: $hzc-white;
          cursor: pointer;
        }

        .box:hover {
          background-color: $light-grey;

          .capacity {
            font-weight: bold;
            color: $hzc-gray-05;
          }
        }

        .box.active {
          margin: -2px;
          border: solid 2px $light-purple;
          background-color: $hzc-white;

          .circle {
            border: solid 4px $light-purple;
          }

          .capacity {
            font-size: 20px;
            font-weight: bold;
            color: $light-purple;
          }
        }

        .box .circle {
          position: absolute;
          top: 6px;
          left: 6px;
          width: 16px;
          height: 16px;
          border-radius: 12px;
          border: solid 1px $border-color;
          background-color: $hzc-white;
        }

        .box .capacity {
          font-size: 16px;
          line-height: 95px;
          letter-spacing: -0.7px;
          text-align: center;
          color: $hzc-gray-05;
        }
      }

      .product-wrap {
        a {
          position: relative;
          display: block;
          margin: 0;
          padding: 14px 8px;
          font-size: 14px;
          font-weight: bold;
          text-decoration: none;
          border-bottom: 1px solid $hzc-gray-04;
          color: $font-color;
          cursor: pointer;
        }

        a .tag {
          margin-right: 8px;
          display: inline-block;
          width: 40px;
          line-height: 20px;
          border-radius: 10px;
          background-color: $hzc-gray-03;
          font-size: 12px;
          font-weight: normal;
          text-align: center;
        }

        a .glyphicon {
          position: absolute;
          top: 18px;
          right: 8px;
          font-size: 16px;
          color: $hzc-gray-05;
        }
      }
    }

    #result {
      padding: 40px 0;
      background-color: $light-grey;

      ul {
        margin: 0;
      }

      .category-list {
        padding: 0 24px 12px;
      }

      .card {
        width: 100%;
        padding: 16px 24px;
        margin: 0 0 8px;
        border-radius: 4px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
        background-color: $hzc-white;

        div[class^=col] {
          padding: 0;
        }

        .category {
          display: none;
        }

        &-header {
          padding: 0;
          .orange-tag {
            width: 57px;
            margin-bottom: 12px;
            border-radius: 11px;
            background-color: #ffe3d6;
            font-size: 12px;
            font-weight: bold;
            line-height: 20px;
            letter-spacing: -0.3px;
            text-align: center;
            color: $orange;
          }
          .capacity {
            font-size: 26px;
            font-weight: bold;
            line-height: 1.31;
            letter-spacing: -1px;
            color: $font-color;
          }
        }

        &-body {
          padding: 0;
          .panel-wrap .combination.name {
            margin: 0 0 18px;
          }
          .panel-wrap .count {
            margin: 2px 0  22px;
          }
          .combination,
          .name {
            font-size: 16px;
            line-height: 1.5;
            letter-spacing: -0.7px;
            color: $font-color;
          }
          .combination small {
            margin-left: 16px;
            font-size: 12px;
            line-height: 1.33;
            letter-spacing: -0.3px;
            color: $hzc-gray-05;
          }
          .count {
            font-size: 14px;
            line-height: 1.57;
            letter-spacing: -0.58px;
            color: $blue-grey;
          }
        }

        &-footer {
          padding: 17px 0;
          button {
            width: 117px;
          }
        }

        @media (max-width: $screen-sm-max) {
          padding: 0;

          .category {
            display: block;
            margin: 0 0 16px;
          }

          .card-header {
            padding: 16px 24px;
            border-bottom: 1px solid $hzc-gray-02;

            .orange-tag {
              margin: 16px 0;
              float: right;
            }
          }

          .card-body {
            padding: 16px 24px 0;
            .row {
              width: 50%;
              float: left;
            }
            .combination {
              margin: 0 0 30px;
            }
            .count {
              margin: 2px 0;
            }
          }

          .card-footer {
            padding: 16px;
            text-align: center;
          }
        }
      }

      .notice {
        padding: 12px 0;
        font-size: 14px;
        line-height: 1.57;
        letter-spacing: -0.58px;
        color: $blue-grey;

        img {
          margin: 0 8px 0 0;
        }
      }

      .more {
        a {
          display: inline-block;
          padding: 14px 48px;
          font-size: 14px;
          font-weight: bold;
          line-height: 1.43;
          letter-spacing: -0.35px;
          color: $font-color;
        }
      }

      .empty {
        padding: 48px 0;
        text-align: center;

        p {
          margin: 0 0 24px;
          font-size: 16px;
          color: $font-color;
        }
      }

      .loader-wrap {
        position: relative;
        height: 240px;

        .loader-content {
          position: absolute;
          top: calc(50% - 32px);
          left: calc(50% - 32px);
          transform: translate(-50%, -50%);
        }
      }

      @media (max-width: $screen-sm-max) {
        padding: 24px 8px;
      }
    }

    #brochure {
      display: none;
      h2 {
        margin: 0 0 48px;
      }

      .category {
        margin: 0 0 12px;
      }

      .checkbox {
        margin: 0 0 32px;
        padding: 0;
      }
    }

    #manufacturer {
      li {
        height: 48px;
        margin-bottom: 16px;
      }

      img {
        max-height: 48px;
        margin: auto;
      }

      .sub-title {
        text-align: center;
        font-size: 40px;
        color: #2E3134;
      }
    }

    #contact {
      position: relative;
      padding-top: 60px;
      padding-bottom: 60px;
      background-image: url("~@/assets/img/product/bg-shop-cs.jpg");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50% 100%;
      text-align: center;

      h2 {
        margin: 0 0 8px;
        font-size: 40px;
        font-weight: bold;
        line-height: 1.25;
        letter-spacing: -2.1px;
        text-align: center;
        color: #7c61e8;
      }

      h3 {
        margin: 0 0 8px;
        font-size: 32px;
        font-weight: normal;
        line-height: 1.25;
        letter-spacing: -1.3px;
        text-align: center;
        color: #ffffff;
      }

      p {
        margin: 0;
        font-size: 16px;
        line-height: 1.33;
        letter-spacing: -0.3px;
        color: #ffffff;
      }

      .pc-memo {
        display: block;
      }
      .m-memo {
        display: none;
      }

      @media (max-width: $screen-xs-max) {
        background-image: url("~@/assets/img/product/bg-shop-cs-xs.jpg");
        .pc-memo {
          display: none;
        }
        .m-memo {
        display: block;
      }
      }
    }

    #applyList {
      display: none;
      h4, .row {
        padding: 0 8px;
      }
    }

    #inquiryModal {
      input, textarea {
        width: 100%;
        padding: 8px;
      }

      .modal-header {
        padding: 24px 16px;
        border: none;

        h5 {
          font-size: 22px;
          font-weight: bold;
          display: inline-block;
        }

        .close {
          width: auto;
        }
      }

      .modal-footer {
        font-size: 12px;
        font-weight: 400;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.17;
        letter-spacing: -.8px;
        text-align: center;
        border: none;
        color: #7a98b6;
        background-color: #f1f3f5;
      }

      .form-group {
        overflow: auto;
      }

      .require-text {
        margin: 0 -15px 15px;
        padding: 8px 24px;
        background-color: #f7f9fa;
        color: $orange;
        font-size: 12px;
      }

      .hz-unit {
        position: absolute;
        top: 8px;
        right: 16px;
        color: $hzc-gray-05;
        font-size: 12px;
        font-weight: bold;
      }

      @media (max-width: $screen-xs-max) {
        .hz-btn-primary {
          width: 100%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Product.vue